export const getThemeData = (state) => state.theme.themeData;
export const getThemeType = (state) => state.theme.themeType;
